const initialState = {
  permisos: [] // Inicializamos con un array vacío para evitar errores en el Menú
};

const user = (state = initialState, action) => {
  switch (action.type) {
    case "SET_USER":
      // Si action.user es nulo (por un logout o error), volvemos al estado inicial
      if (!action.user) return initialState;
      
      return {
        ...state,
        ...action.user // Aquí se fusionarán info del empleado + array de permisos
      };
    
    case "LOGOUT": // Es buena práctica tener un caso de limpieza
      return initialState;

    default:
      return state;
  }
}

export default user;